<template>
  <div>
    <v-container>
      <h2>Data Access</h2>
    </v-container>
    <db-access-form v-if="isItSupport"></db-access-form>
    <db-access-table></db-access-table>
  </div>
</template>

<script>
import DbAccessForm from '@/components/developer/DbAccessForm'
import DbAccessTable from '@/components/developer/DbAccessTable'

export default {
  name: 'DbAccessControl',
  components: {
    DbAccessForm,
    DbAccessTable
  },
  computed: {
    isItSupport() {
      const adminRoles = this.$store.state.currentUserAdminRoles.adminRoles
      return adminRoles.findIndex(i => i.toLowerCase() === 'itsupport') > -1
    }
  }
}
</script>

<style></style>
